import React from 'react';
interface CTAButtonProps {
  label: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  label,
  href = '#comprar',
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] bg-[#B8FF4C] px-6 py-4 text-center text-base font-extrabold text-[#24411D] shadow-lg shadow-[#B8FF4C]/30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B8FF4C] sm:text-[17px] ${className}`} data-id="element-55" data-mp="2kyekuydefntv">
      {label}
    </a>;
}